module.exports = {"loadingText":"Loading configuration for module Report"}